import { ApiClient } from './ApiClient';
import { Condition, ConditionAttributes } from '~/models/Condition';
import { Event } from '~/models/Event';

export default class ConditionApiClient extends ApiClient {
  private readonly BASE_URL: string = '/api/conditions';

  public async provideEventConditions(eventId: number): Promise<Condition[]> {
    const response = await this.get(`${this.BASE_URL}?eventId=${eventId}`);
    return response.data.map((attributes: ConditionAttributes) => new Condition(attributes))
  }

  public async provideCondition(id: number): Promise<Condition> {
    const response = await this.get(`${this.BASE_URL}/${id}`);
    return new Condition(response.data);
  }

  public async createCondition(attributes: ConditionAttributes): Promise<Condition> {
    const response = await this.post(this.BASE_URL, attributes);
    return new Condition(response.data);
  }

  public async updateCondition(attributes: ConditionAttributes): Promise<Condition> {
    const response = await this.patch(this.BASE_URL, attributes);
    return new Condition(response.data);
  }

  public async updateConditions(attributes: ConditionAttributes[]): Promise<Array<Condition>> {
    const response = await this.patch(`${this.BASE_URL}/batch`, attributes);
    return response.data.map((attributes: ConditionAttributes) => new Condition(attributes))
  }

  public async deleteCondition(id: number): Promise<Event> {
    const response = await this.delete(this.BASE_URL, { id });
    return new Event(response.data);
  }

  public async bulkDeleteConditions(idList: Array<number>): Promise<Event> {
    const response = await this.delete(`${this.BASE_URL}/bulk-delete`, idList);
    return new Event(response.data);
  }
}
